import { Navigate, useLocation } from 'react-router-dom'
import { WIKI_BASE } from './wikiLinks'

/**
 * La wiki vivía en `/admin/wiki/*`, dentro del layout del admin. Ahora es un
 * sitio de documentación autónomo en `/wiki/*`; los links ya compartidos
 * rebotan acá conservando ruta, query y ancla. El gate lo pone `/wiki`.
 */
export function RedirectAdminWiki() {
  const { pathname, search, hash } = useLocation()
  const rest = pathname.replace(/^\/admin\/wiki/, '')
  return <Navigate to={{ pathname: `${WIKI_BASE}${rest}`, search, hash }} replace />
}
